import Vue from 'vue'
import { byteLengthDirective } from '../../directives/byte-length'
import clickOutsideDirective from '../../directives/click-outside'
import { scrollDirective } from '../../directives/scroll'

export const registerDirectives = () => {
  Vue.directive('byteLength', byteLengthDirective)
  Vue.directive('clickOutside', clickOutsideDirective)
  Vue.directive('scroll', scrollDirective)
}
